import React, { useEffect } from 'react';

const Dataskyddspolicy = () => {
  useEffect(() => {
    document.title = 'Dataskyddspolicy';
    document.body.className = 'body-4';
    return () => {
      document.body.className = '';
    };
  }, []);

  return (
    <div className="w-layout-vflex">
      <h1 className="heading-3">Dataskyddspolicy</h1>
      <div className="text-block-4">
        Senast uppdaterad: 2025-03-19
        <br />
        Välkommen till Trafikbevakning. Din integritet är viktig för oss. Denna dataskyddspolicy
        förklarar hur vi samlar in, använder och skyddar dina personuppgifter när du använder våra
        tjänster.
        <br />
        <br />
        <strong>1. Kontaktuppgifter</strong>
        <br />
        Om du har några frågor om denna dataskyddspolicy kan du kontakta oss på:
        <br />
        E-post:{' '}
        <a href="mailto:privacy@trafikbevakning.com">
          privacy@trafikbevakning.com
          <br />
          <br />
          <strong>‍</strong>
        </a>
        <strong>2. Vilka uppgifter vi samlar in</strong>
        <br />
        Vi samlar in och behandlar följande personuppgifter:
        <br />
        Användarnamn och lösenord (valda av användaren)
        <br />
        Prenumerationsstatus (för att verifiera en aktiv prenumeration)
        <br />
        <br />
        Vi <em>samlar inte in</em> eller lagrar betalningsinformation. Alla betalningar hanteras
        säkert av <strong>Stripe</strong>. Vi får endast bekräftelse på om en prenumeration är aktiv
        eller inaktiv.
        <br />
        <br />
        <strong>3. Hur vi samlar in uppgifter</strong>
        <br />
        Vi samlar in dessa uppgifter när du gör en betalning via Stripe. Under denna process anger
        du ditt <em>användarnamn</em> och <em>lösenord</em> i två anpassade fält, vilka vi kan se.
        <br />
        <br />
        <strong>4. Syftet med datainsamling</strong>
        <br />
        Vi samlar in och lagrar användardata <em>endast</em> för att verifiera aktiva
        prenumerationer och möjliggöra autentisering till vår tjänst. Vi använder inte dina
        uppgifter för marknadsföring, analys eller andra ändamål.
        <br />
        <br />
        <strong>5. Hur vi lagrar och skyddar uppgifter</strong>
        <br />
        Uppgifterna lagras säkert med <strong>MongoDB Atlas</strong>.<br />
        Vi vidtar lämpliga åtgärder för att skydda dina uppgifter mot obehörig åtkomst, ändring,
        spridning eller förstörelse.
        <br />
        Lösenord lagras säkert med kryptering.
        <br />
        <br />
        <strong>6. Hur länge vi sparar uppgifter</strong>
        <br />
        Vi raderar alla användaruppgifter <em>omedelbart</em> efter att en prenumeration avslutas.
        Inga historiska register sparas.
        <br />
        <br />
        <strong>7. Användares rättigheter </strong>
        <br />
        Enligt Dataskyddsförordningen (GDPR) har du följande rättigheter:
        <br />
        <strong>Tillgång</strong> – Begära en kopia av de uppgifter vi har om dig.
        <br />
        <strong>Rättelse</strong> – Begära korrigering av felaktiga uppgifter.
        <br />
        <strong>Radering</strong> (Rätten att bli bortglömd) – Begära att dina uppgifter raderas.
        <br />
        <strong>Invändning &amp; Begränsning</strong> – Begränsa eller invända mot hur dina
        uppgifter behandlas.
        <br />
        <strong>Återkalla samtycke</strong> – Återkalla ditt samtycke för databehandling (där det är
        tillämpligt).
        <br />
        För att utöva någon av dessa rättigheter, skicka ett e-postmeddelande till{' '}
        <a href="mailto:privacy@trafikbevakning.com">privacy@trafikbevakning.com</a>. Vi svarar så
        snart som möjligt.
        <br />
        <br />
        <strong>8. Cookies</strong>
        <br />
        Vi använder cookies <em>endast för nödvändiga funktioner</em> (t.ex. autentisering och
        upprätthållande av sessionstillstånd). Vi använder <em>inte</em> cookies för spårning,
        analys eller marknadsföringsändamål. En cookie-samtyckesbanner är aktiv på webbplatsen.
        <br />
        <br />
        <strong>9. Datadelning &amp; tredje parter</strong>
        <br />
        Vi säljer, hyr ut eller delar <em>inte</em> dina uppgifter med tredje parter, förutom när
        det är nödvändigt för våra kärntjänster:
        <br />‍<strong>Stripe</strong> (för betalningshantering)
        <br />‍<strong>MongoDB Atlas</strong> (för säker datalagring)
        <br />
        Alla tredjepartstjänster följer GDPR och strikta dataskyddsregler.
        <br />
        <br />
        <strong>10. Ändringar i denna integritetspolicy</strong>
        <br />
        Vi kan uppdatera denna integritetspolicy vid behov. Om väsentliga ändringar görs kommer vi
        att meddela användare via e-post eller genom vår webbplats.
        <br />
        <br />
        Genom att använda våra tjänster godkänner du insamling och användning av dina uppgifter
        enligt denna integritetspolicy.
        <strong>
          <br />‍
        </strong>
        Om du har några frågor, vänligen kontakta oss på{' '}
        <a href="mailto:privacy@trafikbevakning.com">privacy@trafikbevakning.com</a>.<br />
      </div>
    </div>
  );
};

export default Dataskyddspolicy;
